import { Paper } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ChatMessage } from '../../interfaces/AiChat/ChatMessage';

export const AssistantMessage = ({ message }: { message: ChatMessage }) => {
  if (!message.text) return null;

  return (
    <Paper
      sx={{
        width: 'fit-content',
        maxWidth: '70%',
        alignSelf: 'flex-start',
        p: 1.5,
        borderRadius: '10px',
        '& p': { margin: 0 },
        '& pre': {
          margin: 0,
          padding: 1.5,
          borderRadius: '8px',
          overflowX: 'auto',
          backgroundColor: '#111',
          color: '#fff',
        },
        '& code': {
          fontFamily: 'monospace',
        },
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          code(props) {
            const { children, className } = props;
            const text = String(children).replace(/\n$/, '');
            const isBlock = Boolean(className);

            if (!isBlock) {
              return (
                <code
                  style={{
                    background: '#eee',
                    padding: '2px 4px',
                    borderRadius: 4,
                  }}
                >
                  {children}
                </code>
              );
            }

            return (
              <pre>
                <code className={className}>{text}</code>
              </pre>
            );
          },
        }}
      >
        {message.text}
      </ReactMarkdown>
    </Paper>
  );
};
